interface ProjectInfoCardProps {
  projectNumber?: string
  projectName: string
  description: string
  studentGrade: string
  participantCount: string
  minParticipantsPerCompany: string
  maxParticipantsPerCompany: string
}

function ProjectInfoCard({
  projectNumber,
  projectName,
  studentGrade,
  participantCount,
  minParticipantsPerCompany,
  maxParticipantsPerCompany,
}: ProjectInfoCardProps) {
  const rows = [
    ...(projectNumber ? [{ label: '案件番号', value: projectNumber, bold: false }] : []),
    { label: '職場体験名', value: projectName, bold: false },
    { label: '対象学年', value: studentGrade, bold: false },
    { label: '参加生徒数', value: participantCount, bold: false },
  ]
  return (
    <div className="town-info-card">
      <h3 className="town-info-card__title">体験の情報</h3>
      {rows.map(({ label, value, bold }) => (
        <div
          key={label}
          className="town-detail-field"
        >
          <div className="town-detail-field__label">{label}</div>
          <div className={`town-detail-field__value ${bold ? 'town-detail-field__value--bold' : ''}`}>
            {value}
          </div>
        </div>
      ))}
      <div className="town-detail-field is-last">
        <div className="town-detail-field__label">1事業所あたりの参加希望人数</div>
        <div className="town-participant-range">
          <div className="town-participant-range__item">
            <div className="town-participant-range__label">最小</div>
            <div className="town-detail-field__value">{minParticipantsPerCompany}</div>
          </div>
          <div className="town-participant-range__item">
            <div className="town-participant-range__label">最大 </div>
            <div className="town-detail-field__value">{maxParticipantsPerCompany}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectInfoCard
